import * as yup from 'yup'

const schemaProfile = yup.object().shape({
  name: yup.string().required(),
  description: yup.string().required(),
})

export default schemaProfile
